var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDate01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.398 170.16 16 16",
    enableBackground: "new 78.398 170.16 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M92.898,171.16h-0.5v-1h-1v1h-10v-1h-1v1h-0.5c-0.827,0-1.5,0.673-1.5,1.5v12c0,0.827,0.673,1.5,1.5,1.5h13 c0.827,0,1.5-0.673,1.5-1.5v-12C94.398,171.833,93.725,171.16,92.898,171.16z M93.398,184.66c0,0.275-0.225,0.5-0.5,0.5h-13 c-0.275,0-0.5-0.225-0.5-0.5v-8.5h14V184.66z M93.398,175.16h-14v-2.5c0-0.275,0.225-0.5,0.5-0.5h0.5v1h1v-1h10v1h1v-1h0.5 c0.275,0,0.5,0.225,0.5,0.5V175.16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate01);
export default __webpack_public_path__ + "static/media/icon_date-01.b3295a89f30145521f99a5394a16cee8.svg";
export { ForwardRef as ReactComponent };